import RelationFineGroup from './relation_fine_group.vue';
import BudgetSubjectTable from './budget_subject_table.vue';

export {
  BudgetSubjectTable,
};

export default RelationFineGroup;
